import React from 'react';
import { Reveal } from './Reveal';
export function ArtifactSection() {
  return <section className="bg-gradient-to-br from-sage to-[#3D5E45] py-12 px-6 relative overflow-hidden" data-id="element-14">
      <div className="absolute -bottom-[60px] -right-[60px] w-[200px] h-[200px] rounded-full bg-white/5" data-id="element-15"></div>

      <Reveal data-id="element-16">
        <div className="inline-flex items-center gap-1.5 bg-white/15 border border-white/25 text-[10px] font-bold tracking-[0.12em] uppercase py-1 px-3 rounded-full mb-5 text-[#976500]" data-id="element-17">
          🎁 GRATIS · Incluido con tu compra
        </div>

        <h2 className="font-serif text-[36px] font-semibold leading-[1.1] mb-3 text-[#E7A82A]" data-id="element-18">
          Test de Perfil
          <br data-id="element-19" />
          Hormonal
        </h2>

        <p className="text-[14px] leading-[1.7] mb-7 text-[#E7A82A]" data-id="element-20">
          Antes de leer la guía, descubrí exactamente con qué estás trabajando.{' '}
          <strong className="font-semibold text-[#E7A82A]" data-id="element-21">
            12 preguntas. 4 minutos.
          </strong>{' '}
          Resultado personalizado con tu perfil y qué capítulo leer primero.
        </p>

        <div className="grid grid-cols-2 gap-2 mb-7" data-id="element-22">
          <div className="rounded-xl py-3.5 px-3 bg-white/10 border border-white/15" data-id="element-23">
            <span className="text-[20px] mb-1.5 block" data-id="element-24">🌊</span>
            <p className="text-[11px] font-semibold leading-[1.3] text-[#E7A82A]" data-id="element-25">
              Dominancia Estrogénica
            </p>
          </div>
          <div className="rounded-xl py-3.5 px-3 bg-white/10 border border-white/15" data-id="element-26">
            <span className="text-[20px] mb-1.5 block" data-id="element-27">⚡</span>
            <p className="text-[11px] font-semibold leading-[1.3] text-[#E7A82A]" data-id="element-28">
              Cortisol Elevado
            </p>
          </div>
          <div className="rounded-xl py-3.5 px-3 bg-white/10 border border-white/15" data-id="element-29">
            <span className="text-[20px] mb-1.5 block" data-id="element-30">🔄</span>
            <p className="text-[11px] font-semibold leading-[1.3] text-[#E7A82A]" data-id="element-31">
              Resistencia a la Insulina / SOP
            </p>
          </div>
          <div className="rounded-xl py-3.5 px-3 bg-white/10 border border-white/15" data-id="element-32">
            <span className="text-[20px] mb-1.5 block" data-id="element-33">🌿</span>
            <p className="text-[11px] font-semibold leading-[1.3] text-[#E7A82A]" data-id="element-34">
              Transición Hormonal
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2.5" data-id="element-35">
          <div className="flex items-center gap-3" data-id="element-36">
            <span className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center text-[12px] font-bold shrink-0 text-[#E7A82A]" data-id="element-37">
              1
            </span>
            <p className="text-[13px] leading-[1.4] text-[#E7A82A]" data-id="element-38">
              Respondés 12 preguntas sobre tus síntomas
            </p>
          </div>
          <div className="flex items-center gap-3" data-id="element-39">
            <span className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center text-[12px] font-bold shrink-0 text-[#E7A82A]" data-id="element-40">
              2
            </span>
            <p className="text-[13px] leading-[1.4] text-[#E7A82A]" data-id="element-41">
              El test identifica tu perfil hormonal predominante
            </p>
          </div>
          <div className="flex items-center gap-3" data-id="element-42">
            <span className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center text-[12px] font-bold shrink-0 text-[#E7A82A]" data-id="element-43">
              3
            </span>
            <p className="text-[13px] leading-[1.4] text-[#E7A82A]" data-id="element-44">
              Recibís recomendaciones personalizadas y tu ruta de lectura
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}